import React, { Component } from 'react';
import { Group, Transformer } from "react-konva";
import { connect } from 'react-redux';
import { selectObject, multiSelectObject, deleteObject } from "../actions";
import _indexOf from 'lodash/indexOf';

class CanvasLayer extends Component {

  /**
   * @type {Konva.Transformer}
   */
  transformer = null;
  group = null;

  constructor(props) {
    super(props);
    this.handleObjectSelect = this.handleObjectSelect.bind(this);
    this.handleObjectDelete = this.handleObjectDelete.bind(this);
    this.showBoundingBox = this.showBoundingBox.bind(this);
    this.hideBoundingBox = this.hideBoundingBox.bind(this);
    this.reloadFont = this.reloadFont.bind(this);

    // window.FONTPLUS.attachCompleteEvent(() => {
    //   if (this.transformer) {
    //     this.transformer.getLayer().draw();
    //   }
    // });
  }

  UNSAFE_componentWillReceiveProps(newProps, oldProps) {
    if (newProps.layers.selected.length === 1 && newProps.layers.selected[0] === this.props.id) {
      this.showBoundingBox();
    } else {
      this.hideBoundingBox();
    }

    if (newProps.object.type === 'text') {
      const newText = newProps.object.props.text;
      const newFont = newProps.object.props.fontFamily;
      const oldText = oldProps.object ? oldProps.object.props.text : null;
      const oldFont = oldProps.object ? oldProps.object.props.fontFamily : null;

      if (newText !== oldText || newFont !== oldFont) {
        this.reloadFont(newFont, newText, newProps.object.font || {});
      }
    }

  }

  componentDidMount() {
    if (this.props.layers.selected.length === 1 && this.props.layers.selected[0] === this.props.id) {
      this.showBoundingBox();
    }
  }

  handleObjectSelect(e) {
    const stage = this.transformer.getStage();
    const target = stage.findOne(node => {
      //return node.name() === this.props.id;
      return (node.name() === this.props.id);
    });

    const scale = target.scale();

    const size = {
      width: target.getWidth() * scale.x,
      height: target.getHeight() * scale.y
    };

    if (e.evt.shiftKey || e.evt.metaKey) {
      this.props.multiSelectObject(this.props.id, size);
    } else {
      this.props.selectObject(this.props.object, size);
    }

    e.cancelBubble = true;
  }

  handleObjectDelete() {
    if (_indexOf(this.props.layers.selected, this.props.id) !== -1) {
      this.props.deleteObject(this.props.id);
    }
  }

  render() {
    // const draggable = (this.props.layers.selected.length < 2);

    const anchorConfig = {
      full: ['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right'],
      keepRatio: ['top-left', 'top-right', 'bottom-left', 'bottom-right']
    };

    let rotatable = true;
    if (typeof this.props.object.rotateEnabled !== 'undefined') {
      rotatable = this.props.object.rotateEnabled;
    }

    let resizable = true;
    if (typeof this.props.object.resizeEnabled !== 'undefined') {
      resizable = this.props.object.resizeEnabled;
    }

    let anchors = anchorConfig.full;
    if (typeof this.props.object.keepRatio !== 'undefined') {
      anchors = anchorConfig[this.props.object.keepRatio ? 'keepRatio' : 'full'];
    }

    // console.log('Rotatable:', rotatable, this.props.object);
    // console.log('Resizable:', resizable, this.props.object);
    // console.log('KeepRatio:', anchors);

    return (
      // <Group onClick={this.handleObjectSelect} x={0} y={0} draggable={draggable} onDragEnd={this.props.onDragEnd} name={this.props.id + '-group'}>
      <Group onClick={this.handleObjectSelect} onTap={this.handleObjectSelect} name={this.props.id + '-group'} onDragEnd={this.props.onDragEnd}>
        {this.props.children}
        <Transformer
          ref={node => {this.transformer = node;}}
          draggable={true}
          keepRatio={true}
          rotateEnabled={rotatable}
          resizeEnabled={resizable}
          enabledAnchors={anchors}
        />
      </Group>
    );
  }

  showBoundingBox() {

    const stage = this.transformer.getStage();
    const transformer = stage.findOne('#global-transformer-' + this.props.id);
    //console.log(transformer);
    const target = stage.findOne(node => {
      return (node.name() === this.props.id);
    });
    //console.log(target);

    transformer.attachTo(target);
    transformer.moveToTop();
    // this.transformer.getLayer().batchDraw();
    transformer.getLayer().draw();
  }

  hideBoundingBox() {
    const stage = this.transformer.getStage();
    const transformer = stage.findOne('#global-transformer-' + this.props.id);
    const target = stage.findOne(node => {
      return node.name() === this.props.id;
    });

    transformer.detach(target);
    transformer.getLayer().draw();
  }

  reloadFont(font, text, object) {
    if (object.fontplus || false) {
      if (window.FONTPLUS.isloading()) {
        return;
      }

      console.info('Webfont reloading', object);
      window.FONTPLUS.reload();
    }

    console.log('Reloading font');
    this.transformer.getLayer().draw();
    // const observer = new FontFaceObserver(font);
    // observer.load(text).then(() => {
    //   this.transformer.getLayer().draw();
    // }).catch((err) => {
    //   console.error(err);
    // });
  }
}

export default connect(f => f, {selectObject, deleteObject, multiSelectObject})(CanvasLayer);



// WEBPACK FOOTER //
// ./src/components/CanvasLayer.js